import { useCallback, useState } from 'react'

import {
  ActionLink,
  ActionRow,
} from '@/apps/latest/components/molecules/ActionLink'
import { FeedbackDialog } from '@/apps/latest/components/organisms/PostRecordingView/FeedbackDialog'
import { usePostFeedbackMutation } from '@/features/yakureki'
import { useToast } from '@/shared/contexts/ToastContext'

interface Props {
  eventId: string
}

// 完了した記録のページ下部の二次アクションの行。中身は「改善依頼」1 つ。
// 薬剤師の録音後の画面と同じ形 (design-book ADR-0043): 文章 1 欄の dialog → 送信で閉じて toast、
// 画面に状態は残さない (何通でも送れる)。送り先も同じ POST /api/yakureki/<id>/feedback/ で、
// back は SOAP の無い記録 (管理栄養士の報告書) でも受ける。⋯ には入れない (ADR-0043 が再提案しないとしている)。
export const NutritionFeedbackAction = ({ eventId }: Props) => {
  const [open, setOpen] = useState(false)
  const { showToast } = useToast()
  const post = usePostFeedbackMutation()
  const handleSubmit = useCallback(
    async (note: string) => {
      await post.mutateAsync({ yakurekiId: eventId, note })
      showToast('改善依頼を送りました', 'success')
    },
    [eventId, post, showToast]
  )
  return (
    <>
      <ActionRow gapTop={2}>
        <ActionLink label="改善依頼" onClick={() => setOpen(true)} />
      </ActionRow>
      <FeedbackDialog
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleSubmit}
      />
    </>
  )
}
